import { render } from "./App.vue?vue&type=template&id=6133fc8f&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6133fc8f&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=6133fc8f&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6133fc8f"]])

export default __exports__